export default {
      id: "splash-body-usage",
      viewBox: "0 0 2142 649.47",
      url: __webpack_public_path__ + "redesign-sprite.svg#splash-body-usage",
      toString: function () {
        return this.url;
      }
    }